import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useMemo, useRef } from 'react';
// material
import { useTheme } from '@material-ui/core/styles';
import {
    Card,
    Table,
    Stack,
    Avatar,
    Button,
    Checkbox,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TablePagination,
    Grid,
    Menu,
    MenuItem,
    Box,
    Paper,
    Tooltip,
    Chip
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from 'src/redux/store.js';
import { getUserList, deleteUser } from 'src/redux/slices/user.js';
// import { UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';

// routes
// components
import Page from 'src/components/Page.js';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { buildCommunityNavigateState } from 'src/helpers/communityPageNavigation';
import Label from 'src/components/Label.js';
import Scrollbar from 'src/components/Scrollbar.js';
import SearchNotFound from 'src/components/SearchNotFound.js';
import { UserListHead, UserListToolbar, UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { COMPANY_LOGO, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import LoadingScreen from 'src/components/LoadingScreen';
import FullScreenDialogsAllJobs from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogsAllJobs';
import quickbookLogo from '../../assets/quickbookLogo-removebg-preview.png'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import useTableMaxHeight from 'src/hooks/useTableMaxHeight';
import UserOptionsMore from 'src/components/_dashboard/user/list/UserOptionsMore';

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    let aValue = a[orderBy]
    let bValue = b[orderBy]

    // Handle null/undefined values
    if (aValue == null) aValue = ''
    if (bValue == null) bValue = ''

    // Convert to string for consistent comparison
    const aStr = String(aValue)
    const bStr = String(bValue)

    // Use localeCompare for proper alphanumeric sorting
    return bStr.localeCompare(aStr, undefined, {
        numeric: true,
        sensitivity: 'base'
    })
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) return order
        return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
}

// ----------------------------------------------------------------------

export default function CommunityListGrid({ team, isVendor, projectData, setRenderCards, renderCards, isLoading, projectId, setProjectId, openViewPage, setOpenViewPage, projectName, setProjectName, removePopupData, HandleViewProfile, setRefreshClient, noImage, clientProjectBackState,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    fromClient,
    sort
}) {
    const theme = useTheme();
    const dispatch = useDispatch();
    const CommunityListGrid = []; // Replaced CommunityListGrid with onboard_data
    //   const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState('');
    const [filterName, setFilterName] = useState('');
    //   const [rowsPerPage, setRowsPerPage] = useState(10);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const [isDelete, setIsDelete] = useState(false)
    const [openHoldPopup, setOpenHoldPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteTeam, setDeleteTeam] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [setectedRow, setSelectedRow] = useState(null);
    const [viewData, setViewData] = useState(null);
    const [taxCategories, setTaxCategories] = useState(null);
    const [openDeletePop, setOpenDeletePop] = useState(false);
    const [deletingId, setDeletingId] = useState();
    let userDatas = JSON.parse(localStorage.getItem('user'))
    const userType = userDatas.user_type;
    const userId = userDatas.user_id
    const [deletingName, setDeletingName] = useState('');
    const tableScrollRef = useRef(null);
    const tableMaxHeight = useTableMaxHeight(
      tableScrollRef,
      [isLoading, projectData?.length, rowsPerPage, page]
    );
    useEffect(() => {
        if (viewData) {

            fetchTaxCategory()
        }
    }, [viewData])

    const fetchTaxCategory = async () => {
        try {
            const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
            if (response.data.status === 1) {
                let result = response.data.taxResult.filter((data) => viewData.tax_category === data.id)
                console.log("resultresultresult", result)
                setTaxCategories(result[0]);
            } else {
                setTaxCategories(null)
            }
        } catch (error) {
            console.log("Error - ", error);
            setTaxCategories(null)
        }
    }
    console.log('setectedRow=====================', setectedRow)
    let userData = JSON.parse(localStorage.getItem('user'))
    const explodedPermissions = userData?.exploded_permissions
    const handleClose = () => {
        setAnchorEl(null);
    };
    const TABLE_HEAD = [
        { id: 'name', label: 'Name', alignRight: false },
        ...((isVendor || team)
            ? []
            : [{ id: 'type', label: 'Type', alignRight: false }]),
        { id: 'phone_extension', label: 'Phone Extension', alignRight: false },
        { id: 'no_of_requests', label: 'Sales Orders', alignRight: false },
        { id: 'no_of_projects', label: 'Jobs', alignRight: false },
        { id: 'no_of_installs', label: 'Installs', alignRight: false },
        { id: 'no_of_designs', label: 'Designs', alignRight: false },
        { id: 'status', label: 'Status', alignRight: false },
        ...(userData.user_type === 3
            ? []
            : [{ id: 'options', label: 'Options', alignRight: false }])
    ];
    const TABLE_HEAD2 = [
        { id: 'image', label: 'Profile Image', alignRight: false },
        { id: 'name', label: 'Name', alignRight: false },
        ...((isVendor || team)
            ? []
            : [{ id: 'type', label: 'Type', alignRight: false }]),
        { id: 'phone_extension', label: 'Phone Extension', alignRight: false },
        { id: 'status', label: 'Status', alignRight: false },
        ...(userData.user_type === 3
            ? []
            : [{ id: 'options', label: 'Options', alignRight: false }])

    ];
    const getStatusColorAndLabel = (status) => {
        switch (status) {
            case 1:
                return { color: 'success', label: 'Active' }
            case 0:
                return { color: 'warning', label: 'Inactive' }
            case 2:
                return { color: 'error', label: 'Deleted' }
            default:
                return { color: 'default', label: 'Open' }
        }
    }
    useEffect(() => {
        dispatch(getUserList());
    }, [dispatch]);

    // Reset table sort when filter changes
    useEffect(() => {
        setOrder('asc');
        setOrderBy('');
    }, [sort]);

    // Rest of the code remains unchanged from here
    // ...
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // Apply sorting to projectData
    const sortedData = useMemo(() => {
        if (!projectData || projectData.length === 0) return projectData;
        // If orderBy is empty, return data without sorting (default order)
        if (!orderBy) return projectData;
        return applySortFilter(
            [...projectData],
            getComparator(order, orderBy)
        );
    }, [projectData, order, orderBy]);

    // Apply pagination to sorted data
    const paginatedData = useMemo(() => {
        if (!sortedData || sortedData.length === 0) return sortedData;
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return sortedData.slice(startIndex, endIndex);
    }, [sortedData, page, rowsPerPage]);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = CommunityListGrid.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };


    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };

    //   const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    //   };

    //   const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    //   };

    const handleFilterByName = (event) => {
        setFilterName(event.target.value);
    };

    const handleDeleteUser = (userId) => {
        dispatch(deleteUser(userId));
    };

    const emptyRows = paginatedData?.length > 0 ? 0 : 2;

    const isUserNotFound = sortedData?.length === 0;
    const handleClickOpenViewPage = (id, name) => {
        setProjectId(id)
        setProjectName(name)
        setOpenViewPage(true)
        localStorage.setItem("openProductionPopup", "true");
        localStorage.setItem("projectId", id);
        localStorage.setItem("projectName", name);

        // setSearchParams({
        //   open: "true",
        //   // view: "viewPage",
        //   // projectId: id,
        //   // projectName: name,
        // });
    }
    const changeStatus = async (comId, comStatus) => {
        try {
            let deleteId = comId;
            let status = comStatus;
            let response = await axios.post(`${REST_API_END_POINT}community/delete-community`, { deleteId, status, userId });
            //   console.log("response-----------------", response.data);
            if (response.data.status === 1) {
                enqueueSnackbar(response.data.message, { variant: 'success' });
                navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
            }
            else if (response.data.status === 0) {
                enqueueSnackbar(response.data.message, { variant: 'error' });
                navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
            }
            else {
                console.log("Error.........!");
                enqueueSnackbar("Server Error...!", { variant: 'error' });
                navigate(PATH_DASHBOARD.community.root, { state: { data: `${response.data.message}+${deleteId}` } });
            }
        }
        catch (error) {
            console.log("Delete error : ", error);
        }
    }

    const handleDeleteClick = async (id, newStatus) => {
        // console.log("id, newStatus",id, newStatus);
        setDeletingName('');
        setDeletingId();
        setOpenDeletePop(false);
        await changeStatus(id, newStatus);
    }
    const handleMenuClick = async (id, status) => {
        console.log('id=status==================', id, status)
        let newStatus;
        (status === 1) ? newStatus = 0 : newStatus = 1
        // console.log("id, newStatus",id, newStatus);
        await changeStatus(id, newStatus);
    }
    return (
        <>
            <Grid container spacing={3}>
                {isLoading ? <LoadingScreen /> :
                    <Grid item xs={12}>
                        <Card>
                            {/* <ProjectListViewToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

                            <Scrollbar>
                                <TableContainer
                                    ref={tableScrollRef}
                                    sx={{
                                        minWidth: 800,
                                        whiteSpace: "nowrap",
                                        overflowX: "auto",
                                        overflowY: "auto",
                                        maxHeight: tableMaxHeight,
                                        '&::-webkit-scrollbar': {
                                            width: '0.6em',
                                            height: '0.6em',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#1e1e1e', // dark background to blend with dark UI
                                            borderRadius: '4px',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: '#555', // medium-gray thumb
                                            borderRadius: '6px',
                                            border: '2px solid #1e1e1e', // contrast border to separate from track
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            backgroundColor: '#888', // lighter on hover for feedback
                                        },
                                        '&::-webkit-scrollbar-corner': {
                                            backgroundColor: '#1e1e1e' // match your dark background
                                        },
                                    }}
                                >
                                    <Table
                                        stickyHeader
                                        sx={{
                                            '& .MuiTableCell-head': {
                                                padding: '8px 12px',
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                height: '48px',
                                                minHeight: '48px',
                                                maxHeight: '48px',
                                                lineHeight: 1.4,
                                                whiteSpace: 'nowrap',
                                                textAlign: 'left',
                                                verticalAlign: 'middle'
                                            },
                                            '& .MuiTableSortLabel-root': {
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                justifyContent: 'flex-start',
                                                '& .MuiTableSortLabel-icon': {
                                                    marginLeft: '4px'
                                                }
                                            }
                                        }}
                                    >
                                        <UserListHead
                                            order={order}
                                            orderBy={orderBy}
                                            headLabel={noImage ? TABLE_HEAD : TABLE_HEAD2}
                                            rowCount={sortedData?.length}
                                            numSelected={selected?.length}
                                            onRequestSort={handleRequestSort}
                                            onSelectAllClick={handleSelectAllClick}
                                            checkboxPresent={true}
                                        />
                                        <TableBody>
                                            {paginatedData?.map((row) => {
                                                console.log('row===============================', row)
                                                const status = Number(row.status)
                                                const hold = Number(row.hold)
                                                const Newimage = row.thumbnail ? row.thumbnail :
                                                    ((row.client_profile_pic && row.client_profile_pic !== 'avatar.jpg' && row.client_profile_pic !== '')
                                                        ? row.client_profile_pic : COMPANY_LOGO)
                                                const Newname = team ? `${row.first_name}${row.last_name}` : row.name;
                                                return (
                                                    <TableRow
                                                        hover
                                                        key={0}
                                                        sx={{
                                                            '& .MuiTableCell-root': {
                                                                padding: '8px 12px',
                                                                fontSize: '0.75rem',
                                                                height: 'auto',
                                                                lineHeight: 1.4
                                                            }
                                                        }}
                                                    >
                                                        {/* <TableCell padding="checkbox">
                              <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
                            </TableCell> */}
                                                        {/* <TableCell align="right">
                                    <Box sx={{ width: '100%', display: "flex", justifyContent: "center", height: "30px",width:"50px", mt: 2 }}>
                                        {
                                            row.syncWithQuickBook === 1 ?
                                                <img src={quickbookLogo} width={"50px"} height={"30px"} />
                                                : ""
                                        }
                                    </Box>
                                </TableCell> */}
                                                        {!noImage &&
                                                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                                                <Avatar
                                                                    alt={Newname}
                                                                    src={Newimage || 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'}
                                                                    sx={{
                                                                        width: 44,
                                                                        height: 44,
                                                                        // margin: '0 auto',
                                                                    }}
                                                                />
                                                            </TableCell>}
                                                        {/* <TableCell align="center">{row.request_id}</TableCell> */}
                                                        <TableCell align="left" sx={{
                                                            fontSize: '0.75rem',
                                                            maxWidth: '120px',
                                                            '&:hover': {
                                                                cursor: 'pointer',
                                                                textDecoration: 'underline',
                                                            },
                                                        }}
                                                            onClick={() => {
                                                                // HandleViewProfile(row,row.id, Newname);
                                                                setViewData(row);
                                                                // if (communityJob) {
                                                                //   navigate(PATH_DASHBOARD.project.viewproject + row.id, { state: { fromCommunityJob: true } });
                                                                // } else {
                                                                //   handleClickOpenViewPage(row.id, row.name);
                                                                // }
                                                            }}
                                                        >
                                                            <Tooltip title={Newname || ''} arrow>
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    noWrap
                                                                    sx={{
                                                                        fontSize: '0.75rem',
                                                                        maxWidth: 120,
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    }}
                                                                >
                                                                    {Newname}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell align="left" sx={{ fontSize: '0.75rem', maxWidth: '100px' }}>
                                                            <Tooltip title={row.type || ''} arrow>
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    noWrap
                                                                    sx={{
                                                                        fontSize: '0.75rem',
                                                                        maxWidth: { xs: 300, sm: 300, md: 300, lg: 360, xl: 440 },
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    }}
                                                                >
                                                                    {row.type}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                                            {row.phone_extension || '-'}
                                                        </TableCell>
                                                        {noImage &&
                                                            <>
                                                                <TableCell align="left"
                                                                    sx={{
                                                                        fontSize: '0.75rem',
                                                                        '&:hover': {
                                                                            cursor: 'pointer',
                                                                            textDecoration: 'underline',
                                                                        },
                                                                    }}
                                                                    onClick={() => {
                                                                        navigate(PATH_DASHBOARD.community.rfqCommunity, {
                                                                            state: buildCommunityNavigateState(
                                                                                row.id,
                                                                                row?.name,
                                                                                row?.clients,
                                                                                clientProjectBackState,
                                                                            ),
                                                                        })
                                                                    }}
                                                                >{row.no_of_requests}
                                                                </TableCell>
                                                                <TableCell
                                                                    sx={{
                                                                        fontSize: '0.75rem',
                                                                        '&:hover': {
                                                                            cursor: 'pointer',
                                                                            textDecoration: 'underline',
                                                                        },
                                                                    }}
                                                                    onClick={() => {
                                                                        navigate(PATH_DASHBOARD.community.rfqProjects, {
                                                                            state: buildCommunityNavigateState(
                                                                                row.id,
                                                                                row?.name,
                                                                                row?.clients,
                                                                                clientProjectBackState,
                                                                            ),
                                                                        })
                                                                    }}
                                                                    align="left">{row.no_of_projects}</TableCell>
                                                                <TableCell
                                                                    sx={{
                                                                        fontSize: '0.75rem',
                                                                        '&:hover': {
                                                                            cursor: 'pointer',
                                                                            textDecoration: 'underline',
                                                                        },
                                                                    }}
                                                                    onClick={() => {
                                                                        navigate(PATH_DASHBOARD.community.rfqInstalls, {
                                                                            state: buildCommunityNavigateState(
                                                                                row.id,
                                                                                row?.name,
                                                                                row?.clients,
                                                                                clientProjectBackState,
                                                                            ),
                                                                        })
                                                                    }}
                                                                    align="left">{row.no_of_installs}</TableCell>
                                                                <TableCell
                                                                    sx={{
                                                                        fontSize: '0.75rem',
                                                                        '&:hover': {
                                                                            cursor: 'pointer',
                                                                            textDecoration: 'underline',
                                                                        },
                                                                    }}
                                                                    onClick={() => {
                                                                        navigate(PATH_DASHBOARD.community.rfqDesigns, {
                                                                            state: buildCommunityNavigateState(
                                                                                row.id,
                                                                                row?.name,
                                                                                row?.clients,
                                                                                clientProjectBackState,
                                                                            ),
                                                                        })
                                                                    }}
                                                                    align="left">{row.no_of_designs}</TableCell>
                                                            </>
                                                        }
                                                        {/* <TableCell align="center">{row.community_name}</TableCell>
                            <TableCell align="center">{row.authorized_by}</TableCell>
                            <TableCell align="center">{row.member_count}</TableCell> */}
                                                        {/* <TableCell align="center">{row.city==='DefaultCity' ? '' : row.city}</TableCell> */}

                                                        <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                                            <Label
                                                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                                                color={getStatusColorAndLabel(status).color} >
                                                                {getStatusColorAndLabel(status).label}
                                                            </Label>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <UserOptionsMore
                                                                onDelete={() => {
                                                                    if (explodedPermissions?.some(permission => ['Delete Projects'].includes(permission))) {
                                                                        setOpenDeletePop(true);
                                                                        setDeletingId(row?.id);
                                                                        setDeletingName(row?.name);
                                                                    } else {
                                                                        enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                                                    }
                                                                }}
                                                                onEdit={() => {
                                                                    if (explodedPermissions?.some(permission => ['Edit Projects'].includes(permission)) || userType === 3) {
                                                                        navigate(PATH_DASHBOARD.community.create, { state: { data: row?.id } })
                                                                    } else {
                                                                        enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                                                    }
                                                                }}
                                                                onStatusChange={() => {
                                                                    if (explodedPermissions?.some(permission => ['Activate/Deactivate Projects'].includes(permission))) {
                                                                        handleMenuClick(row?.id, status)
                                                                    } else {
                                                                        enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                                                    }
                                                                }}
                                                                status={status}
                                                                oppName={row?.name}
                                                                oppId={row?.id}
                                                                project={true}
                                                                userType={userType}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );

                                            })}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        {isUserNotFound && (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                                                        <SearchNotFound searchQuery={filterName} />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                </TableContainer>
                            </Scrollbar>

                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100, 500]}
                                component="div"
                                count={totalCount}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Card>

                    </Grid>
                }

            </Grid>
            <FullScreenDialogsAllJobs
                initialFromCalender={"false"}
                open={openViewPage}
                removePopupData={removePopupData}
                setOpen={setOpenViewPage}
                renderCards={renderCards}
                handleClickOpen={handleClickOpenViewPage}
                projectName={projectName}
                projectId={projectId}
                setRenderCards={setRenderCards}
            />
            <ConfirmationPopup
                open={openDeletePop}
                handleClose={() => { setOpenDeletePop(false) }}
                message={`You want to delete ${deletingName} ! `}
                handleClick={() => { handleDeleteClick(deletingId, 2) }}
            />
            <Modal
                modalTitle={'View Project'}
                open={viewData ? true : false}
                handleClose={() => {
                    setViewData(null)
                }}
            >
                <Grid container sx={{ justifyContent: 'center', }} spacing={3}>
                    <Grid item xs={12} md={12}>
                        <Stack
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}
                            spacing={3}
                        >
                            <Paper
                                key={'ddf'}
                                sx={{
                                    p: 3,
                                    width: 1,
                                    bgcolor: 'background.neutral'
                                }}
                            >
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.name ? 'inherit' : 'inherit' }}>
                                        Name : {viewData?.name}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.description ? 'inherit' : 'inherit' }}>
                                        Description : {viewData?.description}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.type ? 'inherit' : 'inherit' }}>
                                        Project Type : {viewData?.type}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.type ? 'inherit' : 'inherit' }}>
                                        Clients : {viewData?.clientName}
                                    </span>
                                </Typography>

                                {viewData?.po_details && viewData.po_details.length > 0 && (
                                    <>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                                            <Typography variant="subtitle1" gutterBottom>PO#:</Typography>
                                            {viewData.po_details.map((po, index) => (
                                                <Tooltip title={`PO Number: ${po.po_number}`} key={index}>
                                                    <Chip
                                                        key={index}
                                                        label={po.po_name || `PO ${index + 1}`}
                                                        size="small"
                                                        variant="outlined"
                                                        color="primary"
                                                    />
                                                </Tooltip>
                                            ))}
                                        </Box>
                                    </>)}
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.email ? 'inherit' : 'inherit' }}>
                                        Email : {viewData?.email}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.phone ? 'inherit' : 'inherit' }}>
                                        Contact No : {viewData?.phone}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.phone_extension ? 'inherit' : 'inherit' }}>
                                        Phone Extension : {viewData?.phone_extension || '-'}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.address ? 'inherit' : 'inherit' }}>
                                        Address : {viewData?.address}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.authorized_by ? 'inherit' : 'inherit' }}>
                                        Created By : {viewData?.authorized_by}
                                    </span>
                                </Typography>

                                {/* <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.tax_category ? 'inherit' : 'inherit' }}>
                                        Tax Category: {taxCategories ? taxCategories?.name : 'Nill'}
                                    </span>
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <span style={{ color: viewData?.tax_category ? 'inherit' : 'inherit' }}>
                                        Tax Value: {taxCategories ? `${taxCategories?.value} ${taxCategories?.type == 1 ? '%' : '$'}` : 'Nill'}
                                    </span>
                                </Typography> */}
                                <Typography variant="body2" gutterBottom>
                                    Status {' '}
                                    <Label
                                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                        color={(viewData?.status === 1 && 'success') || 'error'}
                                    >
                                        {(viewData?.status === 1) ? " Active" : " Inactive"}
                                    </Label>
                                </Typography>
                            </Paper>
                            <Box
                                sx={{
                                    mt: 3,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: 1,
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setViewData(null)
                                    }}
                                >
                                    Close
                                </Button>
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>
            </Modal>
        </>
    );
}
